import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

export type TelaRotina = LazyExoticComponent<ComponentType<{ codigo: string }>>;

export const telaSobDemanda = <K extends string>(
  carregar: () => Promise<Record<K, ComponentType<{ codigo: string }>>>,
  nome: K,
): TelaRotina => lazy(() => carregar().then((modulo) => ({ default: modulo[nome] })));

/** Ação extra no cabeçalho do detalhe de um registro, por código de rotina (`acoesDetalheRotina`). */
export type AcaoDetalhe = LazyExoticComponent<ComponentType<{ registro: { id: number } }>>;

export const acaoDetalheSobDemanda = <K extends string>(
  carregar: () => Promise<Record<K, ComponentType<{ registro: { id: number } }>>>,
  nome: K,
): AcaoDetalhe => lazy(() => carregar().then((modulo) => ({ default: modulo[nome] })));
